<template>
  <carousel
    :per-page="perPageNumber"
    :per-page-custom="[
      [0, 1],
      [768, 2],
      [1024, perPageNumber]
    ]"
    :loop="true"
    navigation-next-label="<span class='icon bis-right'></span>"
    navigation-prev-label="<span class='icon bis-left'></span>"
    :navigation-enabled="false"
    pagination-active-color="#00CB94"
    pagination-color="#d4d4d4"
    class="carouser-wrapper"
  >
    <slot></slot>
  </carousel>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
  name: "AppGallery",
  components: {
    Carousel,
    Slide
  },
  props: {
    perPage: {
      default: 1
    }
  },
  computed: {
    perPageNumber() {
      return parseInt(this.perPage);
    }
  }
};
</script>

<style scoped lang="scss" type="text/scss">
.icon {
  font-size: 34px;
}

.VueCarousel-pagination {
  position: absolute;
  bottom: 0%;
}

.VueCarousel-navigation-button {
  display: none;
  font-size: 56px;
  color: #4e1d1e !important;
  line-height: 1;
  background-color: rgba(0, 0, 0, 0.6) !important;

  @media (max-width: 1024px) {
    font-size: 40px;
  }
}

.VueCarousel:hover,
.VueCarousel:focus {
  .VueCarousel-navigation-button {
    display: block !important;
  }
}

.VueCarousel-navigation-prev {
  transform: translateY(-50%) translateX(0%) !important;

  @media (max-width: 768px) {
    font-size: 28px;
  }
}

.VueCarousel-navigation-next {
  transform: translateY(-50%) translateX(0) !important;

  @media (max-width: 768px) {
    font-size: 28px;
  }
}
</style>
